import * as signalR from "@microsoft/signalr";

export default function HeartRateHub(props: {
    sn?: string;
    setHeartRateData?: Function;
}) {
    const { sn, setHeartRateData } = props;

    if (!sn) {
        console.error("HeartRateHub: Serial number (sn) is required");
        return () => {};
    }

    let connection = new signalR.HubConnectionBuilder()
        .withUrl(`${process.env.REACT_APP_BASE_URL}heartRateHub`)
        .build();

    connection
        .start()
        .then(() => {
            console.log("Started HeartRateHub for sn:", sn);
            connection.invoke("SubscribeToHeartRateData", sn);
        })
        .catch((err: any) => {
            console.error(`HeartRateHub error for sn ${sn}:`, err.toString());
        });

    connection.on("ReceiveSensorData", (data: any) => {
        console.log("Raw heart rate data received for sn:", sn, "data:", data);
        console.log("Heart rate Data type:", typeof data);
        const formattedData = typeof data === "number" ? { sn, value: data } : { sn, ...data };
        setHeartRateData && setHeartRateData([formattedData]);
    });

    return () => {
        console.log("Stopping HeartRateHub connection for sn:", sn);
        connection.stop();
    };
}